export interface HLabel {
  text: string;
  children?: HLabel[];
}
/**
 * https://daodou.yuque.com/bccm6k/wunzps/sfr0bsee9xiw2oig?singleDoc#drkC
 */

export const CommonFooter: HLabel = {
  text: 'Hairpaca',
  children: [{ text: 'FEATURES' }, { text: 'RESOURCES' }, { text: 'PRODUCT' }, { text: 'WORK WITH US' }]
};
export const HLabelMap = new Map<string, HLabel>();

HLabelMap.set('hairstyle', {
  text: '20K+ Hairstyle Ideas for Everyone: Find Your Perfect Look',
  children: [
    {
      text: 'Find the Perfect Hairstyle by Gender',
      children: [{ text: 'Hairstyle Ideas for Man' }, { text: 'Hairstyle Ideas for Women' }]
    },
    {
      text: 'Discover Age-Appropriate Hairstyles',
      children: [
        { text: 'Best Hair Ideas for Aged' },
        { text: 'Trendy Hair Ideas for Young People' },
        { text: 'Adorable Haircuts for Kids' }
      ]
    },
    {
      text: 'Explore Hairstyles by Hair Color',
      children: [{ text: 'Blonde' }, { text: 'Brown' }, { text: 'Grey' }, { text: 'Red' }, { text: 'Black' }]
    },
    {
      text: 'Find Styles by Hair Length',
      children: [{ text: 'Long Hair Ideas' }, { text: 'Medium Hair Ideas' }, { text: 'Short Hair Ideas' }]
    },
    CommonFooter
  ]
});

HLabelMap.set('influencers', {
  text: 'Find the best hairstyles by top hair influencers of 2025',
  children: [
    {
      text: 'Top Hair Styles Influencers',
      children: [
        { text: 'Braided' },
        { text: 'Slicked back' },
        { text: 'Quiff' },
        { text: 'Swept back' },
        { text: 'Updo' },
        { text: 'Braids' },
        { text: 'Messy bun' },
        { text: 'Hair accessory' }
      ]
    },
    {
      text: 'Top Influencers for Different Hair Types',
      children: [{ text: 'Wavy' }, { text: 'Curly' }, { text: 'Straight' }, { text: 'Afro' }]
    },
    {
      text: 'Top Hair Cuts Influencers',
      children: [
        { text: 'Bob cut' },
        { text: 'Undercut' },
        { text: 'Buzz cut' },
        { text: 'Curly top' },
        { text: 'Short sides' }
      ]
    },
    {
      text: 'Top Hairstyle Influencers for Different Hair Lengths',
      children: [{ text: 'Long' }, { text: 'Short' }, { text: 'Medium length' }, { text: 'Shoulder length' }]
    },
    CommonFooter
  ]
});

HLabelMap.set('plan', {
  text: 'Hairpaca Pricing: Find the best hair solution',
  children: [
    {
      text: 'Our Subscription Plans',
      children: [{ text: 'Style Starter' }, { text: 'Style Pro' }, { text: 'Style Elite' }]
    },
    {
      text: 'Our One-time Payment',
      children: [{ text: '100 Credits' }, { text: '100 Credits' }, { text: '100 Credits' }]
    },
    { text: 'Secure Payment with Stripe' },
    {
      text: 'FAQ About Our Pricing',
      children: [
        { text: 'How do Credits work?' },
        { text: 'What are Extra Hairpaca Credits?' },
        { text: 'Can I keep my Credits after my subscription expires?' },
        { text: 'What is the Curated Hairstyle Catalog?' },
        { text: 'Can I upgrade my subscription?' },
        { text: 'Can I cancel my Hairpaca Subscription?' }
      ]
    },
    CommonFooter
  ]
});

HLabelMap.set('hairpaca-api', {
  text: 'Effortless Virtual Hairstyling with Hairpaca API',
  children: [
    {
      text: 'For All Your Hairstyling Needs',
      children: [
        {
          text: 'Hair Salons & Stylists'
        },
        {
          text: 'Hair Care Brands'
        },
        {
          text: 'Wig Merchants'
        },
        {
          text: 'Influencers'
        },
        {
          text: 'Events & Photoshoots'
        },
        {
          text: 'Fashion Retailers'
        }
      ]
    },
    { text: 'Contact Us via Email' },
    CommonFooter
  ]
});
